import dayjs from 'dayjs';

export const DATA_GRID_DEFAULT_CURRENT_PAGE = 1;
export const DATA_GRID_DEFAULT_PER_PAGE = 20;
export const DATA_GRID_SORT_ORDER_ASC = 'asc';
export const DATA_GRID_SORT_ORDER_DESC = 'desc';
export const DATA_GRID_DEFAULT_PAGE_SIZES = [10, 20, 30, 40, 50].map((size) => ({
  label: size.toString(),
  value: size,
}));
export const PISANO_FOUNDATION_DATE = dayjs().year(2015).startOf('year').toDate();
